<template>
  <form>
    <div class="b-text-color--sonic-silver">
      {{ header }}
    </div>
    <LoginMessage :message="message" :active="valid"></LoginMessage>
    <slot></slot>
  </form>
</template>

<script>
import LoginMessage from '@/views/pages/login/LoginMessage'

export default {
  name: 'CommonPagesForm',
  components: {LoginMessage},
  props: {
    header: {
      type: String,
      default: 'Заполните форму, пожалуйста:'
    },
    message: {
      type: String,
      required: false
    }
  },
  data: () => ({
    valid: true
  }),
  watch: {
    message(value) {
      this.valid = value !== ''
    }
  }
}
</script>

<style scoped></style>
